// import React from "react";
// // import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/effect-fade";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// import { herobg1,herobg2,herobg3 } from "./index"; // Adjust the path as necessary

// const slides = [
//   {
//     image: herobg1,
//     title: "Experience the perfect blend of tradition and innovation with copper and brass, the ultimate cookware duo.",
//     link: "/collections",
//   },
//   {
//     image: herobg2,
//     title: "Cook like a pro with our hand-crafted copper sets – beauty meets performance.",
//     link: "/collections",
//   },
//   {
//     image: herobg3,
//     title: "Timeless elegance for your kitchen – explore our brass cookware collection.",
//     link: "/collections",
//   },
// ];

// const Hero = () => {
//   return (
//     <div className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
//       <Swiper
//         modules={[Autoplay, Pagination, Navigation, EffectFade]}
//         autoplay={{ delay: 4000, disableOnInteraction: false }}
//         pagination={{ clickable: true }}
//         navigation
//         loop
//         effect="fade"
//         fadeEffect={{ crossFade: true }}
//         className="w-full h-full"
//       >
//         {slides.map((slide, index) => (
//           <SwiperSlide key={index}>
//             <div className="relative w-full h-full">
//               <img
//                 src={slide.image}
//                 alt={slide.title}
//                 className="object-cover w-full h-full absolute inset-0"
//               />
//               {/* <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
//                 <div className="max-w-3xl text-center px-4">
//                   <div className="bg-[#6D5D5D] p-6 bg-opacity-50 rounded-lg backdrop-blur-none animate-fade-in-down duration-700">
//                     <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-serif mb-4">
//                       {slide.title}
//                     </h2>
//                     <Link to={slide.link}>
//                       <button className="bg-[#73340E] hover:bg-[#C09670] text-white border-none mt-4 px-6 py-2 rounded">
//                         EXPLORE MORE
//                       </button>
//                     </Link>
//                   </div>
//                 </div>
//               </div> */}
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default Hero;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
// import { Phone, Mail, Facebook, Linkedin, Instagram, Menu, X } from "lucide-react";
// import "swiper/css";
// import "swiper/css/effect-fade";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// import { herobg1,herobg2,herobg3,logo } from "./index";

// const slides = [
//   {
//     image: herobg1,
//     title: "Experience the perfect blend of tradition and innovation with copper and brass, the ultimate cookware duo.",
//     link: "/collections",
//   },
//   {
//     image: herobg2,
//     title: "Cook like a pro with our hand-crafted copper sets – beauty meets performance.",
//     link: "/collections",
//   },
//   {
//     image: herobg3,
//     title: "Timeless elegance for your kitchen – explore our brass cookware collection.",
//     link: "/collections",
//   },
// ];

// const Hero = () => {
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <section className="relative h-screen">
//       {/* Transparent Header */}
//       <header className="absolute top-0 left-0 w-full z-50">
//         <div className="w-full bg-black/30 text-white py-2 px-4 flex flex-col md:flex-row justify-between items-center">
//           {/* Contact Information */}
//           <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
//             <div className="flex items-center space-x-2">
//               <Phone size={16} />
//               <span>+91 9619688998</span>
//             </div>
//             <div className="flex items-center space-x-2">
//               <Mail size={16} />
//               <span>theglobalgreet@gmail.com</span>
//             </div>
//           </div>

//           {/* Social Media Links */}
//           <div className="flex items-center space-x-4 mt-2 md:mt-0">
//             <a href="#" className="text-white hover:text-amber-100">
//               <Facebook size={20} />
//             </a>
//             <a href="#" className="text-white hover:text-amber-100">
//               <Linkedin size={20} />
//             </a>
//             <a href="#" className="text-white hover:text-amber-100">
//               <Instagram size={20} />
//             </a>
//           </div>
//         </div>

//         {/* Main Navigation */}
//         <div className="w-full bg-transparent py-4 px-6 flex justify-between items-center">
//           {/* Logo */}
//           <div className="flex items-center space-x-3">
//             <img
//               src={logo}
//               alt="Logo"
//               className="w-20 h-26 object-contain"
//             />
//             {/* <div className="hidden md:block">
//               <h1 className="text-2xl font-serif text-white">Global Greet</h1>
//               <span className="text-sm text-amber-50">Connecting Cultures, Delivering Quality</span>
//             </div> */}
//           </div>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex space-x-8">
//             <Link to="/" className="text-white hover:text-amber-200 text-lg">
//               Home
//             </Link>
//             <Link to="/aboutus" className="text-white hover:text-amber-200 text-lg">
//               About Us
//             </Link>
//             <Link to="/collections" className="text-white hover:text-amber-200 text-lg">
//               Collection
//             </Link>
//             <Link to="/certificates" className="text-white hover:text-amber-200 text-lg">
//               Certificate
//             </Link>
//             <Link to="/contact-us" className="text-white hover:text-amber-200 text-lg">
//               Contact Us
//             </Link>
//           </nav>

//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden text-white"
//             onClick={() => setMenuOpen(true)}
//           >
//             <Menu size={32} />
//           </button>
//         </div>
//       </header>

//       {/* Image Slider */}
//       <Swiper
//         modules={[Autoplay, EffectFade]}
//         autoplay={{ delay: 5000 }}
//         effect="fade"
//         className="h-full w-full"
//       >
//         {slides.map((slide, index) => (
//           <SwiperSlide key={index}>
//             <div className="relative h-full w-full">
//               <img
//                 src={slide.image}
//                 alt={slide.title}
//                 className="object-cover w-full h-full"
//               />
//               <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
//                 <div className="text-center text-white max-w-2xl px-4">
//                   <h1 className="text-4xl md:text-5xl font-bold mb-6">
//                     {slide.title}
//                   </h1>
//                   <Link
//                     to={slide.link}
//                     className="inline-block bg-amber-600 hover:bg-amber-700 text-white px-8 py-3 rounded-lg text-lg"
//                   >
//                     Explore Collections
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>

//       {/* Features Grid */}
//       <div className="absolute bottom-0 left-0 w-full bg-black/60 py-8">
//         <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4">
//           {['FAST DELIVERY', 'QUALITY PRODUCTS', 'SUPERIOR SUPPORT', 'TRUSTED BRAND'].map((feature) => (
//             <div key={feature} className="text-center text-white p-4">
//               <h3 className="text-xl font-bold mb-2">{feature.split(' ')[0]}</h3>
//               <p className="text-sm">{feature.split(' ').slice(1).join(' ')}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Mobile Menu Overlay */}
//       <div
//         className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${
//           menuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//         onClick={() => setMenuOpen(false)}
//       >
//         {/* Mobile Menu Content */}
//         <div
//           className={`absolute right-0 top-0 h-full w-64 bg-white transform transition-transform duration-300 ${
//             menuOpen ? 'translate-x-0' : 'translate-x-full'
//           }`}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="flex justify-between items-center p-4 border-b">
//             <div className="flex items-center space-x-2">
//               <img
//                 src="/globalgreetlogo.png"
//                 alt="Logo"
//                 className="w-12 h-12 object-contain"
//               />
//               <h1 className="text-xl font-serif text-[#73340E]">Global Greet</h1>
//             </div>
//             <button
//               className="text-gray-600 hover:text-gray-800"
//               onClick={() => setMenuOpen(false)}
//             >
//               <X size={24} />
//             </button>
//           </div>

//           <nav className="flex flex-col p-4 space-y-4">
//             <Link to="/" className="text-gray-700 hover:text-amber-600">
//               Home
//             </Link>
//             <Link to="/aboutus" className="text-gray-700 hover:text-amber-600">
//               About Us
//             </Link>
//             <Link to="/collections" className="text-gray-700 hover:text-amber-600">
//               Collection
//             </Link>
//             <Link to="/certificates" className="text-gray-700 hover:text-amber-600">
//               Certificate
//             </Link>
//             <Link to="/contact-us" className="text-gray-700 hover:text-amber-600">
//               Contact Us
//             </Link>
//           </nav>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

// Hero.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import Header from "./Header";
import { herobg1, herobg2, herobg3, herobg4 } from "./index";
import feature from "./index";

const slides = [
  { image: herobg1, title: "ORGANIC FERTILIZERS" },
  { image: herobg2, title: "HERBAL & NATURAL PRODUCTS" },
  { image: herobg3, title: "BAGASSE TABLEWARE" },
  { image: herobg4, title: "COCOPEAT - COIR PRODUCTS" },
];

const Hero = () => {
  return (
    <section className="relative">
      <Header />

      {/* Image Slider with Specialization Box */}
      <div className="relative h-[45vh] min-h-[500px]">
        <Swiper
          modules={[Autoplay, EffectFade]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: true,
          }}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          speed={1000}
          className="h-full w-full"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="relative h-full w-full">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="object-cover w-full h-full absolute inset-0"
                />
                {/* Specialization Box */}
                <div className="absolute left-0 bottom-8 z-20">
                  <div className="bg-[#D9B58F] p-4 md:p-6 text-white border-r-8 border-[#B99063]">
                    <h1 className="text-xl md:text-2xl font-bold text-[#000000]">
                      SPECIALISED IN
                    </h1>
                    <h2 className="text-xl md:text-2xl font-bold text-[#000000]">
                      {slide.title}
                    </h2>
                  </div>
                </div>

                {/* Overlay to ensure text visibility */}
                <div className="absolute inset-0 bg-black/20 z-100"></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Features Grid */}
      <section className="grid grid-cols-2 md:grid-cols-5">
        <div className="bg-[#77422B] text-white p-4 flex flex-col items-center justify-center text-center">
          <div className="mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
            >
              <g fill="none" fill-rule="evenodd">
                <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                <path
                  fill="currentColor"
                  d="M13.586 2A2 2 0 0 1 15 2.586L19.414 7A2 2 0 0 1 20 8.414V20a2 2 0 0 1-2 2h-5a1 1 0 1 1 0-2h5V10h-4.5A1.5 1.5 0 0 1 12 8.5V4H6v4a1 1 0 0 1-2 0V4a2 2 0 0 1 2-2zM7 10a4 4 0 0 1 3 6.646v4.192a1.1 1.1 0 0 1-1.592.984L7 21.118l-1.408.704A1.1 1.1 0 0 1 4 20.838v-4.192A4 4 0 0 1 7 10m1 7.874a4 4 0 0 1-2 0v1.508l.553-.276a1 1 0 0 1 .894 0l.553.276zM7 12a2 2 0 1 0 0 4a2 2 0 0 0 0-4m7-7.586V8h3.586z"
                />
              </g>
            </svg>
          </div>
          <h3 className="text-xs md:text-sm font-semibold">Organic</h3>
          <p className="text-xs md:text-sm font-semibold">Certified</p>
        </div>

        <div className="bg-[#A05E2A] text-white p-4 flex flex-col items-center justify-center text-center">
          <div className="mb-2">
            <img
              src={feature.feature2}
              alt="Superior Quality"
              width={40}
              height={40}
            />
          </div>
          <h3 className="text-xs md:text-sm font-semibold">BATCH</h3>
          <p className="text-xs md:text-sm font-semibold">TESTED</p>
        </div>

        <div className="bg-[#77422B] text-white p-4 flex flex-col items-center justify-center text-center">
          <div className="mb-2">
            <img
              src={feature.feature1}
              alt="Fast Delivery"
              width={40}
              height={40}
            />
          </div>
          <h3 className="text-xs md:text-sm font-semibold">FAST</h3>
          <p className="text-xs md:text-sm font-semibold">DELIVERY</p>
        </div>

        <div className="bg-[#AE7349] text-white p-4 flex flex-col items-center justify-center text-center">
          <div className="mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="m283.735 52.918l31.295 26.614a42.7 42.7 0 0 0 24.213 10.03l40.947 3.309c20.86 1.686 37.42 18.246 39.106 39.106l3.31 40.947a42.7 42.7 0 0 0 10.029 24.213l26.614 31.294c13.557 15.942 13.557 39.362 0 55.304l-26.614 31.295a42.7 42.7 0 0 0-10.03 24.213l-3.31 40.947c-1.685 20.86-18.246 37.42-39.105 39.106l-40.947 3.31a42.7 42.7 0 0 0-24.213 10.029l-31.295 26.614c-15.942 13.557-39.362 13.557-55.304 0l-31.294-26.614a42.7 42.7 0 0 0-24.213-10.03l-40.947-3.31c-20.86-1.685-37.42-18.246-39.106-39.105l-3.31-40.947a42.7 42.7 0 0 0-10.03-24.213l-26.613-31.295c-13.557-15.942-13.557-39.362 0-55.304l26.614-31.294a42.7 42.7 0 0 0 10.03-24.213l3.309-40.947c1.686-20.86 18.246-37.42 39.106-39.106l40.947-3.31a42.7 42.7 0 0 0 24.213-10.03l31.294-26.613c15.942-13.557 39.362-13.557 55.304 0m52.6 126.863L234.667 282.002l-48.916-48.916l-30.167 30.166l79.083 79.084l131.836-132.388z"
              />
            </svg>
          </div>
          <h3 className="text-xs md:text-sm font-semibold">PREMIUM</h3>
          <p className="text-xs md:text-sm font-semibold">QUALITY</p>
        </div>

        <div className="bg-[#C8934F] text-white p-4 flex flex-col items-center justify-center text-center">
          <div className="mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
            >
              <g fill="none" fill-rule="evenodd">
                <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                <path
                  fill="currentColor"
                  d="M11.298 2.195a2 2 0 0 1 1.232-.055l.172.055l7 2.625a2 2 0 0 1 1.291 1.708l.007.165v5.363a9 9 0 0 1-4.709 7.911l-.266.139l-3.354 1.677a1.5 1.5 0 0 1-1.198.062l-.144-.062l-3.354-1.677a9 9 0 0 1-4.97-7.75l-.005-.3V6.693a2 2 0 0 1 1.145-1.808l.153-.065zm4.135 6.434l-4.598 4.598l-1.768-1.768a1 1 0 0 0-1.414 1.415l2.404 2.404a1.1 1.1 0 0 0 1.556 0l5.234-5.235a1 1 0 1 0-1.414-1.414"
                />
              </g>
            </svg>{" "}
          </div>
          <h3 className="text-xs md:text-sm font-semibold">TRUSTED</h3>
          <p className="text-xs md:text-sm font-semibold">PRODUCT</p>
        </div>
      </section>
    </section>
  );
};

export default Hero;
